import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPopupShown } from "../../store/Slices/userSlice.js";
import Slider from "react-slick";
import "./Dashboard.scss";
import billingColumns from "../../columns/dashboard/columns";
import SkeletonTable from "../../components/table/SkeletonTable";
import {
  GetClientDashboard,
  GetBannerDashboard,
  SubmitSignatureApi,
} from "../../api/request/dashboard/dashboard";
import toast from "react-hot-toast";
import moment from "moment";
import { Form, Image, Progress, Spin, Upload } from "antd";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { saveAs } from "file-saver";
import ModalComponent from "../../components/modals/ModalComponent";
import LoadableButton from "../../components/button/LoadableButton";
import PaymentModal from "./components/PaymentModal";
import siteConfig from "../../config";
import CreateFiles from "../files/components/CreateFiles";
import CreateFileModal from "../files/components/CreateFileModal";
import StartFileModal from "./components/StartFileModal";
import totalFileColumns from "../../columns/totalfiles/totalfiles.js";
import View from "../../assets/View.jsx";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isPopupShown } = useSelector((state) => state.user);
  const [dashboardData, setDashboardData] = useState([]);
  const [services, setServices] = useState([]);
  const [billingData, setBillingData] = useState([]);
  const [dashboardCards, setDashboardCards] = useState([
    {
      title: "In-Process Files",
      total: 0,
      icon: "/assets/icons/inprocess-files.svg",
      bgColor: "bg-[#cdd8ec] ",
      path: "/files",
      state: { status: "inprocess" },
    },
    {
      title: "Closed Files",
      total: 0,
      icon: "/assets/icons/closed-files.svg",
      bgColor: "bg-[#E5FAFF]",
      path: "/files",
      state: { status: "closed" },
    },
    {
      title: "Communications",
      total: 0,
      icon: "/assets/icons/ticket.svg",
      bgColor: "bg-[#DDF6E8]",
      path: "/chat",
    },
    {
      title: "Action Required",
      total: 0,
      icon: "/assets/icons/apply-signature.svg",
      bgColor: "bg-[#cfcced]",
    },
  ]);

  const [uploadFileForm] = Form.useForm();
  const [documentId, setDocumentId] = useState("");
  const [isOpenUploadModal, setIsOpenUploadModal] = useState(false);
  const [isUploadFileLoading, setIsUploadFileLoading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [payment, setPayment] = useState({});
  const [isOpenPaymentModal, setIsOpenPaymentModal] = useState(false);
  const [showIntialPopup, setShowIntialPopup] = useState(false);
  const [isCreateFileOpen, setIsCreateFileOpen] = useState(false);
  const [isReasonOpen, setIsReasonOpen] = useState(false);

  const contactInfo = [
    {
      label: "Phone",
      icon: "/assets/icons/phone.svg",
      value: dashboardData?.site_setting?.phone,
      url: `tel:${dashboardData?.site_setting?.phone}`,
    },
    {
      label: "Email",
      icon: "/assets/icons/email.svg",
      value: dashboardData?.site_setting?.email,
      url: `mailto:${dashboardData?.site_setting?.email}`,
    },
    {
      label: "Address",
      icon: "/assets/icons/location.svg",
      value: dashboardData?.site_setting?.address,
      url: dashboardData?.site_setting?.address_url,
    },
    {
      label: "Website",
      icon: "/assets/icons/web.svg",
      value: dashboardData?.site_setting?.website_url,
      url: dashboardData?.site_setting?.website_url,
    },
  ];

  const socialLinks = [
    {
      name: "Facebook",
      icon: "/assets/icons/facebook.svg",
      url: dashboardData?.site_setting?.facebook_url,
      bgColor: "bg-[#3B599933]",
    },
    {
      name: "Instagram",
      icon: "/assets/icons/instagram.svg",
      url: dashboardData?.site_setting?.instagram_url,
      bgColor:
        "bg-gradient-to-b from-[rgba(219,0,172,0.2)] to-[rgba(255,203,0,0.2)]",
    },
    {
      name: "LinkedIn",
      icon: "/assets/icons/linkedin.svg",
      url: dashboardData?.site_setting?.linkedin_url,
      bgColor: "bg-[#0B69C733]",
    },
    {
      name: "LinkedIn",
      icon: "/assets/icons/twiter.svg",
      url: dashboardData?.site_setting?.twitter_url,
      bgColor: "bg-[#0B69C733]",
    },
  ];

  const bannerSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  const handleFileView = (data) => {
    navigate(`/file/${data?.files_id}`);
  };

  const getDashboardDetails = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetClientDashboard();
      const { data: bannerData } = await GetBannerDashboard();
      if (bannerData?.status) {
        setBannerData(bannerData?.data);
      }
      if (data?.status) {
        setDashboardData(data?.data);
        const updatedTotals = [
          data?.data?.in_process_files,
          data?.data?.closed_files,
          data?.data?.communications,
          data?.data?.action_required,
        ];
        setDashboardCards(
          dashboardCards?.map((card, index) => ({
            ...card,
            total: updatedTotals[index] || 0,
          }))
        );
        setServices(
          data?.data?.services?.map((item) => {
            return {
              ...item,
              progress: (
                <Progress
                  percent={Number(item?.completion_percentage).toFixed(0)}
                />
              ),
              status: (
                <span
                  className={`px-3 py-1 rounded-full inline-flex items-center justify-center w-28 h-6 text-white text-xs font-semibold uppercase ${
                    item.files_status === " closed"
                      ? "bg-green-500"
                      : item.files_status === "inprocess"
                      ? "bg-primary"
                      : "bg-orange-500"
                  }`}
                >
                  {item.files_status}
                </span>
              ),
              action: (
                <div onClick={(e) => e.stopPropagation()}>
                  <button onClick={() => handleFileView(item)}>
                    <View />
                  </button>
                </div>
              ),
            };
          }) || []
        );

        if (!data?.data?.total_files && !isPopupShown) {
          setShowIntialPopup(true);
          dispatch(setPopupShown(true));
        }
        setBillingData(
          data?.data?.billing_details?.map((item) => {
            const isShowPayBtn = !item?.request_sended || item?.reason;
            return {
              ...item,
              action: (
                <div className="flex items-center gap-5">
                  <a
                    href={item?.files?.invoice_pdf?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-blue-500"
                  >
                    View Invoice
                  </a>

                  {isShowPayBtn && (
                    <button
                      className="btn-primary !px-4 !py-1"
                      onClick={() => {
                        setPayment(item);
                        setIsOpenPaymentModal(true);
                      }}
                    >
                      Pay
                    </button>
                  )}
                </div>
              ),
              status: getStatus(item),
            };
          })
        );
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDashboardDetails();
  }, []);

  const getStatus = (item) => (
    <>
      {item?.reason ? (
        <div title={item?.reason} className="flex items-center gap-2">
          <p className="font-bold uppercase text-red-600">Rejected</p>
          <img
            src="/assets/icons/info.svg"
            className="size-4 cursor-pointer"
            onClick={() => {
              setPayment(item);
              setIsReasonOpen(true);
            }}
          />
        </div>
      ) : (
        <>
          {item?.request_sended ? (
            <p className="font-bold text-[#FF9800]">Wait For Verification</p>
          ) : (
            <p
              className={`font-bold uppercase ${
                item?.status === "paid" ? "text-green-500" : "text-red-600"
              }`}
            >
              {item?.status}
            </p>
          )}
        </>
      )}
    </>
  );

  const setStatusData = () => {
    setBillingData((prev) => {
      return prev.map((item) => {
        if (item?.id === payment?.id) {
          const updatedData = { ...item, request_sended: true, reason: "" };
          return {
            ...updatedData,
            status: getStatus(updatedData),
            action: (
              <a
                href={item?.files?.invoice_pdf?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-blue-500"
              >
                View Invoice
              </a>
            ),
          };
        }
        return item;
      });
    });
  };

  const downloadPDF = (url) => {
    if (!url) return;
    saveAs(url, url.split("/").pop());
  };

  const submitSignature = async (values) => {
    if (!documentId) return;
    try {
      setIsUploadFileLoading(true);
      const params = {
        document_id: documentId,
        file: values?.files[0]?.originFileObj,
      };
      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      const { data } = await SubmitSignatureApi(params, apiHeader);
      if (data?.status) {
        toast.success(data?.message);
        uploadFileForm.resetFields();
        setDocumentId("");
        setIsOpenUploadModal(false);
        getDashboardDetails();
      }
      setIsUploadFileLoading(false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsUploadFileLoading(false);
    }
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    uploadFileForm.setFieldsValue({ files: newFileList });
    if (newFileList?.length === 0) {
      uploadFileForm.setFieldsValue({ files: [] });
    }
  };

  return (
    <div className="grid sm:grid-cols-4 gap-5 sm:px-0 px-1">
      <div className="sm:col-span-3 space-y-5">
        <div
          className={`dashboard-banner rounded-xl overflow-hidden h-[250px] ${
            isLoading ? "bg-[#0bafd450]" : "bg-primary"
          }`}
        >
          <div className="flex justify-center items-center h-full w-full">
            {isLoading ? (
              <Spin />
            ) : (
              <Slider {...bannerSettings} className="h-full w-full">
                {bannerData?.map((item) => (
                  <img
                    src={item?.image}
                    alt="Banner"
                    className="h-[250px] w-full object-cover"
                  />
                ))}
              </Slider>
            )}
          </div>
        </div>

        <div className="grid sm:grid-cols-4 gap-5">
          {dashboardCards?.map((item, index) => (
            <div
              key={index}
              className="border rounded-xl p-4 bg-white cursor-pointer"
              onClick={() => navigate(item?.path, { state: item?.state })}
            >
              <div className="flex justify-between items-center h-full">
                <div>
                  <p className="card-count mb-1">{item.total}</p>
                  <p className="sub-title">{item.title}</p>
                </div>
                <div
                  className={`${item.bgColor} rounded-xl size-14 flex items-center justify-center`}
                >
                  <img src={item.icon} alt="icon" />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div>
          <CreateFiles showCancel={false} />
        </div>

        {(dashboardData?.waiting_for_action?.length > 0 ||
          billingData?.length > 0) && (
          <div className="border rounded-2xl p-6 bg-White">
            <h3 className="title mb-4">Waiting for action</h3>

            {dashboardData?.waiting_for_action?.length > 0 && (
              <div>
                {dashboardData?.waiting_for_action?.map((item, index) => (
                  <div
                    key={index}
                    className={`border rounded-md flex justify-between items-center p-4 my-3 ${
                      item?.is_sign_done
                        ? "border-green-600 cursor-not-allowed"
                        : "border-Gray"
                    }`}
                  >
                    <div>
                      <p
                        className={`text-lg capitalize ${
                          item?.is_sign_done ? "text-green-600" : ""
                        }`}
                      >
                        {item?.original_name}
                      </p>
                      <div className="flex items-center gap-3">
                        <p className="text-sm text-Gray mt-1">
                          {moment(item?.updated_at).format("lll")}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      {item?.is_sign_done ? (
                        <p className="text-green-600 font-semibold text-base">
                          Signed
                        </p>
                      ) : (
                        <>
                          <LoadableButton
                            lable="Download"
                            onClick={() => downloadPDF(item?.path)}
                          />
                          <LoadableButton
                            lable="Upload"
                            onClick={() => {
                              setDocumentId(item?.id);
                              setIsOpenUploadModal(true);
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {billingData?.length > 0 && (
              <div>
                <p className="m-5 title">Billing Details</p>
                <div className="overflow-x-auto">
                  <SkeletonTable
                    columns={billingColumns}
                    data={billingData}
                    isLoading={isLoading}
                    pagination={false}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {services?.length ? (
          <div className="border rounded-xl p-5 bg-White">
            <p className="title mb-4">Total Files ({services.length})</p>
            <div className="overflow-x-auto">
              <SkeletonTable
                columns={totalFileColumns}
                data={services}
                isLoading={isLoading}
                onRowClick={(data) => handleFileView(data)}
              />
            </div>
          </div>
        ) : null}
      </div>
      <div className="border rounded-2xl w-full space-y-5 bg-White">
        <div>
          <div className="bg-[#F1F1F1] py-2 ps-4 rounded-t-2xl title">
            Contact Info
          </div>
          <div className="px-4">
            {isLoading ? (
              <div className="!flex !justify-center !items-center min-h-[250px] w-full z-20">
                <Spin />
              </div>
            ) : (
              contactInfo?.map((item, index) => (
                <div
                  key={index}
                  className={`border-b flex items-center gap-3 py-2 ${
                    !!item?.value ? "" : "hidden"
                  }`}
                >
                  <div className="h-5 border-r pe-2">
                    <img src={item?.icon} alt="icon" />
                  </div>
                  <div className="w-[calc(100%-50px)] truncate">
                    <p className="text-Gray text-sm">{item?.label}</p>
                    <a
                      key={index}
                      href={item?.url || "#"}
                      target={
                        ["Phone", "Email"].includes(item?.label)
                          ? "_self"
                          : item?.url
                          ? "_blank"
                          : "_self"
                      }
                      rel="noopener noreferrer"
                    >
                      {item?.value}
                    </a>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <div>
          <div className="bg-[#F1F1F1] py-2 ps-4 title">Social Links</div>
          <div className="flex gap-3 py-4 px-4">
            {socialLinks?.map((item, index) => (
              <a
                key={index}
                href={item.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className={`${
                  item.bgColor
                } h-8 w-8 rounded-full flex justify-center items-center ${
                  item.url ? "cursor-pointer" : "hidden"
                }`}
              >
                <img src={item.icon} alt={item.name} className="h-5 w-5" />
              </a>
            ))}
          </div>
          <div className="px-4 py-4">
            <div className="bg-[#F1F1F1] rounded-xl text-center content-center p-6">
              <h4 className="title">Download mobile app</h4>
              <p className="text-sm py-2 px-1">
                Download {siteConfig.name} to manage and track your documents
                anytime, anywhere—effortlessly!
              </p>
              <div className="gap-3 flex justify-center items-center pt-4 ">
                <a
                  href={dashboardData?.site_setting?.playstore_url || "#"}
                  target={
                    dashboardData?.site_setting?.playstore_url ? "_blank" : ""
                  }
                  rel="noopener noreferrer"
                  className="h-10 inline-block"
                >
                  <img
                    src="/assets/icons/playstore-btn.svg"
                    alt="Play Store"
                    className="object-contain h-full"
                  />
                </a>
                <a
                  href={dashboardData?.site_setting?.applestore_url || "#"}
                  target={
                    dashboardData?.site_setting?.applestore_url ? "_blank" : ""
                  }
                  rel="noopener noreferrer"
                  className="h-10 inline-block"
                >
                  <img
                    src="/assets/icons/appstore-btn.svg"
                    alt="App Store"
                    className="object-contain h-full"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- UPload file modal --- */}
      <ModalComponent
        isOpen={isOpenUploadModal}
        setIsOpen={setIsOpenUploadModal}
        title="Upload Signed File"
        width={600}
      >
        <Form
          className="w-full"
          autoComplete="off"
          form={uploadFileForm}
          initialValues={{ files: [] }}
          onFinish={submitSignature}
        >
          <div>
            <Form.Item
              name="files"
              rules={[{ required: true, message: "Please upload file." }]}
            >
              <Upload
                beforeUpload={() => false}
                listType="picture-card"
                fileList={fileList}
                onChange={handleChange}
              >
                {fileList.length >= 1 ? null : (
                  <button
                    type="button"
                    className="flex flex-col items-center gap-2"
                  >
                    <div className="size-7">
                      <img src="/assets/icons/upload.svg" alt="icon" />
                    </div>
                    Upload
                  </button>
                )}
              </Upload>
            </Form.Item>
            {previewImage && (
              <Image
                wrapperStyle={{ display: "none" }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(""),
                }}
                src={previewImage}
              />
            )}
          </div>
          <LoadableButton
            className="mt-4"
            type="submit"
            lable="Upload"
            isLoading={isUploadFileLoading}
            loadingLable="Uploading file..."
          />
        </Form>
      </ModalComponent>

      {/* --- Payment modal --- */}
      <PaymentModal
        isOpen={isOpenPaymentModal}
        setIsOpen={setIsOpenPaymentModal}
        payment={payment}
        setStatusData={setStatusData}
      />

      {/* --- Reason modal --- */}
      <ModalComponent
        title="Payment Rejected Reason"
        isOpen={isReasonOpen}
        setIsOpen={setIsReasonOpen}
      >
        <p className="text-base text-center">{payment?.reason}</p>
      </ModalComponent>

      {/* --- Start file modal --- */}
      <StartFileModal
        isOpen={showIntialPopup}
        setIsOpen={setShowIntialPopup}
        setIsCreateFileOpen={setIsCreateFileOpen}
      />

      {/* Create file modal */}
      <CreateFileModal
        isOpen={isCreateFileOpen}
        setIsOpen={setIsCreateFileOpen}
      />
    </div>
  );
};

const CustomPrevArrow = ({ onClick }) => (
  <div
    className="bg-secondaryLight h-[38px] w-[38px] absolute left-4 top-1/2 transform -translate-y-1/2 rounded-full flex justify-center items-center pr-1 cursor-pointer z-10"
    onClick={onClick}
  >
    <img
      src="/assets/icons/left-angle.svg"
      alt="prev"
      className="object-contain"
    />
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div
    className="bg-secondaryLight h-[38px] w-[38px] absolute right-4 top-1/2 transform -translate-y-1/2 rounded-full flex justify-center items-center pl-1 cursor-pointer"
    onClick={onClick}
  >
    <img
      src="/assets/icons/right-angle.svg"
      alt="next"
      className="object-contain"
    />
  </div>
);

export default Dashboard;
